import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { DEFAULT_TRACING_COOKIE_NAME, executeGraphQLQuery, executeContentGraphQLQuery, getCardManagementLabels, getFooterLabels, getInnBusinessHeaderLabels, ID_TOKEN_COOKIE, parseRegistrationQuestions, resolveAndDownloadBlob, getUserManagementLabels, getSpendingLabels, getInnBusinessLayoutLabels, getPathForLocale, getNotificationsLabels } from '..';
import { GET_COUNTRIES, getEmployeesQuery, getEmployeeByIdQuery, getRegistrationQuestionsQuery, GET_ACCOUNT_LIST, GET_ADDRESSES, LOCALES, CountryCode, GET_HOTEL_INFORMATION, HOTEL_AVAILABILITY_QUERY, STATIC_HOTEL_INFORMATION_QUERY, ShortCountry, GET_FORMATTED_ADDRESS, RegistrationRole, BUSINESS_BOOKER_USER_ROLES, getInnBusinessCommonIcons as getInnBusinessCommonIconsQuery, getCompanyRegistrationQuestionsQuery, GET_CONTACT_PREFERENCES, BRANDCODES, getProfileDetailsQuery, getCompanyDetailsQuery, managementInformationReportQuery, emergencyReportQuery, getAllPibaCards as getAllPibaCardsQuery, getPibaCardDetailsQuery, getCompanySpendingQuery, getYourSpendingQuery, getUpcomingBookingsQuery, getUpcomingSpendingQuery, getPaymentCards as getPaymentCardsQuery, getPayApplicationsQuery, getNotificationsQuery, companyDetailsLookupQuery, WORLDLINE_USER_PREFERENCES_QUERY, getAppLookupDataQueryEN, getAppLookupDataQueryDE, GET_SEARCH_RULES_QUERY, getPayApplicationDetailsQuery, getActivationDetailsQuery, getRegistrationInfoQuery, GET_ANONYMOUS_NEWSLETTER_PREFERENCES, getAccountSpendingQuery, viewAccountTransactionsQuery, getIBActivationDetailsQuery, getEmployeesWithFilteringOptionsQuery, appPreCheckQuery, GET_COOKIE_CONSENT_INFO, getCostCenterDetailsQuery } from '@whitbread-eos/api';
import { roomDefaultValueIfError } from '../../helpers/roomHelpers';
import { logger } from '../../logger/logger';
import decodeIdToken from '../../utils/decodeIdToken';
import { getUnleashTogglesServerOrClient } from '../../utils/unleash';
import { getDetailsFromToken } from '../edge';
import { cachePromise } from '../helpers';
var getNextCookies = function () {
  var _ref = _asyncToGenerator(function* () {
    if (typeof window !== 'undefined') return null;
    try {
      var _yield$import = yield import('next/headers'),
        cookies = _yield$import.cookies;
      return cookies;
    } catch (_unused) {
      return null;
    }
  });
  return function getNextCookies() {
    return _ref.apply(this, arguments);
  };
}();
export var getCostCenterDetails = function () {
  var _ref2 = _asyncToGenerator(function* (token, tetheredUserGuid, logContext) {
    return yield executeGraphQLQuery(getCostCenterDetailsQuery(), {
      tetheredUserGuid
    }, result => {
      var _result$data;
      if (!(result !== null && result !== void 0 && result.errors) && !!(result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.getCostCentreDetails)) {
        var _result$data2;
        return result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.getCostCentreDetails;
      }
      return [];
    }, token, false, true, undefined, logContext);
  });
  return function getCostCenterDetails(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var getCountriesList = function () {
  var _ref3 = _asyncToGenerator(function* (language) {
    return yield executeContentGraphQLQuery(GET_COUNTRIES, {
      language,
      country: language === 'en' ? 'gb' : 'de',
      site: 'business-booker'
    }, result => {
      var _result$data3;
      return result === null || result === void 0 || (_result$data3 = result.data) === null || _result$data3 === void 0 || (_result$data3 = _result$data3.countries) === null || _result$data3 === void 0 ? void 0 : _result$data3.countries;
    });
  });
  return function getCountriesList(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var getUserDetails = function () {
  var _ref4 = _asyncToGenerator(function* (token) {
    var revalidateCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _decodeIdToken = decodeIdToken(token),
      email = _decodeIdToken.email;
    if (!email) {
      return null;
    }
    return getProfileDetails(email, token, revalidateCache, headers);
  });
  return function getUserDetails(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var getAccountRegistrationRoleDetails = account => {
  var registrationRoles = account === null || account === void 0 ? void 0 : account.registrationRoles;
  var isValidArray = Array.isArray(registrationRoles);
  var rolesLength = isValidArray ? registrationRoles.length : 0;
  var oneRole = rolesLength === 1;
  var twoRoles = rolesLength === 2;
  var hasOneRole = isValidArray && oneRole;
  var hasTwoRoles = isValidArray && twoRoles;
  return {
    isOnlyCardHolder: hasOneRole && registrationRoles.includes(RegistrationRole.CardHolder),
    isOnlyFinanceUser: hasOneRole && registrationRoles.includes(RegistrationRole.FinanceUser),
    isOnlyCostCenter: hasOneRole && registrationRoles.includes(RegistrationRole.CostCentreUser),
    isCardHolderAndFinanceUser: hasTwoRoles && registrationRoles.includes(RegistrationRole.CardHolder) && registrationRoles.includes(RegistrationRole.FinanceUser),
    isCardHolderAndCostCenterUser: hasTwoRoles && registrationRoles.includes(RegistrationRole.CardHolder) && registrationRoles.includes(RegistrationRole.CostCentreUser)
  };
};
export var getAccessLevel = function () {
  var _ref5 = _asyncToGenerator(function* (accountHolderNumber) {
    var _cookieStore$get$valu, _cookieStore$get, _userDetails$business, _userDetails$business2, _selectedAccountHolde, _selectedAccountHolde2, _selectedAccountHolde3;
    var cookiesFn = yield getNextCookies();
    var cookieStore = cookiesFn ? yield cookiesFn() : null;
    var token = (_cookieStore$get$valu = cookieStore === null || cookieStore === void 0 || (_cookieStore$get = cookieStore.get(ID_TOKEN_COOKIE)) === null || _cookieStore$get === void 0 ? void 0 : _cookieStore$get.value) !== null && _cookieStore$get$valu !== void 0 ? _cookieStore$get$valu : '';
    var _yield$Promise$all = yield Promise.all([getUserDetails(token), getAccountList(token)]),
      _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2),
      _yield$Promise$all2$ = _yield$Promise$all2[0],
      userDetails = _yield$Promise$all2$ === void 0 ? null : _yield$Promise$all2$,
      _yield$Promise$all2$2 = _yield$Promise$all2[1],
      accounts = _yield$Promise$all2$2 === void 0 ? [] : _yield$Promise$all2$2;
    var accessLevel = userDetails === null || userDetails === void 0 || (_userDetails$business = userDetails.business) === null || _userDetails$business === void 0 ? void 0 : _userDetails$business.accessLevel;
    var selectedAccountHolder = accountHolderNumber ? getSelectedAccountHolder(accounts, accountHolderNumber) : accounts === null || accounts === void 0 ? void 0 : accounts[0];
    return {
      accessLevel,
      isTravelManager: accessLevel === BUSINESS_BOOKER_USER_ROLES.SUPER,
      isBooker: accessLevel === BUSINESS_BOOKER_USER_ROLES.BOOKER,
      isSelfBooker: accessLevel === BUSINESS_BOOKER_USER_ROLES.SELF,
      isGuest: accessLevel === BUSINESS_BOOKER_USER_ROLES.STAYER,
      isBusinessPayManager: accessLevel === BUSINESS_BOOKER_USER_ROLES.BUSINESS_PAY_MANAGER,
      isBusinessPayUser: accessLevel === BUSINESS_BOOKER_USER_ROLES.BUSINESS_PAY_USER,
      isTethered: !!(userDetails !== null && userDetails !== void 0 && (_userDetails$business2 = userDetails.business) !== null && _userDetails$business2 !== void 0 && _userDetails$business2.tethered) && accounts.length > 0,
      hasAccountHolder: hasAccountHolder(accounts),
      hasCardHolder: hasCardHolder(accounts),
      hasCostCenterHolder: hasCostCenterHolder(accounts),
      selectedAccount: {
        isCardHolder: !!(selectedAccountHolder !== null && selectedAccountHolder !== void 0 && (_selectedAccountHolde = selectedAccountHolder.registrationRoles) !== null && _selectedAccountHolde !== void 0 && _selectedAccountHolde.includes(RegistrationRole.CardHolder)),
        isAccountHolder: !!(selectedAccountHolder !== null && selectedAccountHolder !== void 0 && (_selectedAccountHolde2 = selectedAccountHolder.registrationRoles) !== null && _selectedAccountHolde2 !== void 0 && _selectedAccountHolde2.includes(RegistrationRole.AccountHolder)),
        isCostCenterHolder: !!(selectedAccountHolder !== null && selectedAccountHolder !== void 0 && (_selectedAccountHolde3 = selectedAccountHolder.registrationRoles) !== null && _selectedAccountHolde3 !== void 0 && _selectedAccountHolde3.includes(RegistrationRole.CostCentreUser))
      }
    };
  });
  return function getAccessLevel(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
export var hasCostCenterHolder = accountList => {
  return !!(accountList && accountList.some(x => {
    var _x$registrationRoles;
    return (_x$registrationRoles = x.registrationRoles) === null || _x$registrationRoles === void 0 ? void 0 : _x$registrationRoles.includes(RegistrationRole.CostCentreUser);
  }));
};
export var hasAccountHolder = accountList => {
  return !!(accountList && accountList.some(x => {
    var _x$registrationRoles2;
    return (_x$registrationRoles2 = x.registrationRoles) === null || _x$registrationRoles2 === void 0 ? void 0 : _x$registrationRoles2.includes(RegistrationRole.AccountHolder);
  }));
};
export var getAllPayRoles = accountList => {
  if (!accountList) return [];
  return Array.from(new Set(accountList.flatMap(account => {
    var _account$registration;
    return (_account$registration = account.registrationRoles) !== null && _account$registration !== void 0 ? _account$registration : [];
  })));
};
export var hasCardHolder = accountList => {
  return !!(accountList && accountList.some(x => {
    var _x$registrationRoles3;
    return (_x$registrationRoles3 = x.registrationRoles) === null || _x$registrationRoles3 === void 0 ? void 0 : _x$registrationRoles3.includes(RegistrationRole.CardHolder);
  }));
};
export var getUserRolesForAccount = function () {
  var _ref6 = _asyncToGenerator(function* (account) {
    try {
      var _cookieStore$get$valu2, _cookieStore$get2, _userDetails$business3, _account$registration2;
      var cookiesFn = yield getNextCookies();
      var cookieStore = cookiesFn ? yield cookiesFn() : null;
      var token = (_cookieStore$get$valu2 = cookieStore === null || cookieStore === void 0 || (_cookieStore$get2 = cookieStore.get(ID_TOKEN_COOKIE)) === null || _cookieStore$get2 === void 0 ? void 0 : _cookieStore$get2.value) !== null && _cookieStore$get$valu2 !== void 0 ? _cookieStore$get$valu2 : '';
      var userDetails = yield getUserDetails(token);
      var accessLevel = userDetails === null || userDetails === void 0 || (_userDetails$business3 = userDetails.business) === null || _userDetails$business3 === void 0 ? void 0 : _userDetails$business3.accessLevel;
      return {
        wl: (_account$registration2 = account === null || account === void 0 ? void 0 : account.registrationRoles) !== null && _account$registration2 !== void 0 ? _account$registration2 : [],
        bb: accessLevel ? [accessLevel] : []
      };
    } catch (_unused2) {
      return {
        wl: [],
        bb: []
      };
    }
  });
  return function getUserRolesForAccount(_x7) {
    return _ref6.apply(this, arguments);
  };
}();
export var getCompanyDetails = function () {
  var _ref7 = _asyncToGenerator(function* (companyId, token) {
    var revalidateCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var logContext = arguments.length > 3 ? arguments[3] : undefined;
    return yield executeGraphQLQuery(getCompanyDetailsQuery(), {
      companyId
    }, result => {
      var _result$data4;
      return result === null || result === void 0 || (_result$data4 = result.data) === null || _result$data4 === void 0 ? void 0 : _result$data4.companyDetailsV3;
    }, token, revalidateCache, false, undefined, logContext);
  });
  return function getCompanyDetails(_x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}();
export var getLocationResults = function () {
  var _ref8 = _asyncToGenerator(function* (value) {
    var includeHotels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var url = "".concat(process.env.NEXT_PUBLIC_SNOWDROP_BASE_URL, "v1/autocomplete?input=/").concat(value, "&gplaces[components]=country:uk|country:de");
    if (includeHotels) {
      url += '&hotels.limit=100';
    }
    var response = yield fetch(url);
    return response.json();
  });
  return function getLocationResults(_x0) {
    return _ref8.apply(this, arguments);
  };
}();
export var getRegistrationQuestionsWithAnswers = function () {
  var _ref9 = _asyncToGenerator(function* (employeeId) {
    var _cookieStore$get$valu3, _cookieStore$get3;
    var cookiesFn = yield getNextCookies();
    var cookieStore = cookiesFn ? yield cookiesFn() : null;
    var token = (_cookieStore$get$valu3 = cookieStore === null || cookieStore === void 0 || (_cookieStore$get3 = cookieStore.get(ID_TOKEN_COOKIE)) === null || _cookieStore$get3 === void 0 ? void 0 : _cookieStore$get3.value) !== null && _cookieStore$get$valu3 !== void 0 ? _cookieStore$get$valu3 : '';
    var _getDetailsFromToken = getDetailsFromToken(token),
      companyId = _getDetailsFromToken.companyId;
    return yield executeGraphQLQuery(getRegistrationQuestionsQuery(), {
      companyId,
      employeeId
    }, result => {
      var _result$data5;
      return parseRegistrationQuestions(result === null || result === void 0 || (_result$data5 = result.data) === null || _result$data5 === void 0 ? void 0 : _result$data5.getEmployeeRegistrationQuestionsAndAnswers);
    }, token, true);
  });
  return function getRegistrationQuestionsWithAnswers(_x1) {
    return _ref9.apply(this, arguments);
  };
}();
export var getCookieConsentInfo = function () {
  var _ref0 = _asyncToGenerator(function* (country, language, brand) {
    return yield executeGraphQLQuery(GET_COOKIE_CONSENT_INFO, {
      country,
      language,
      brand
    }, result => result === null || result === void 0 ? void 0 : result.data);
  });
  return function getCookieConsentInfo(_x10, _x11, _x12) {
    return _ref0.apply(this, arguments);
  };
}();
export var getEmployees = function () {
  var _ref1 = _asyncToGenerator(function* (companyId, size, token, page, searchCriteria, pageToken, bookingChannel, awaitingApproval, employeeId, logContext) {
    return yield executeGraphQLQuery(getEmployeesQuery(), {
      companyId,
      size,
      page,
      searchCriteria,
      pageToken,
      bookingChannel,
      awaitingApproval,
      employeeId
    }, result => {
      var _result$data6;
      return result === null || result === void 0 || (_result$data6 = result.data) === null || _result$data6 === void 0 ? void 0 : _result$data6.getEmployeesV2;
    }, token, true, false, undefined, logContext);
  });
  return function getEmployees(_x13, _x14, _x15, _x16, _x17, _x18, _x19, _x20, _x21, _x22) {
    return _ref1.apply(this, arguments);
  };
}();
export var getEmployeeDetails = function () {
  var _ref10 = _asyncToGenerator(function* (companyId, employeeId, token, logContext) {
    return yield executeGraphQLQuery(getEmployeeByIdQuery(), {
      companyId,
      employeeId
    }, result => {
      var _result$data7;
      return result === null || result === void 0 || (_result$data7 = result.data) === null || _result$data7 === void 0 ? void 0 : _result$data7.getEmployeeDetailsV3;
    }, token, true, false, undefined, logContext);
  });
  return function getEmployeeDetails(_x23, _x24, _x25, _x26) {
    return _ref10.apply(this, arguments);
  };
}();
export var getProfileDetails = function () {
  var _ref11 = _asyncToGenerator(function* (customerId, token) {
    var revalidateCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return yield executeGraphQLQuery(getProfileDetailsQuery(), {
      customerId,
      business: true,
      innBusiness: true
    }, result => {
      var _result$data8;
      return result === null || result === void 0 || (_result$data8 = result.data) === null || _result$data8 === void 0 ? void 0 : _result$data8.getProfileDetailsV3;
    }, token, revalidateCache, false, headers);
  });
  return function getProfileDetails(_x27, _x28) {
    return _ref11.apply(this, arguments);
  };
}();
export var getCommonIcons = function () {
  var _ref12 = _asyncToGenerator(function* (language, logContext) {
    var data = yield executeContentGraphQLQuery(getInnBusinessCommonIconsQuery(), {
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data9;
      return result === null || result === void 0 || (_result$data9 = result.data) === null || _result$data9 === void 0 || (_result$data9 = _result$data9.getPageData) === null || _result$data9 === void 0 ? void 0 : _result$data9.commonIconsEndpoint;
    }, logContext);
    return data ? JSON.parse(data) : null;
  });
  return function getCommonIcons(_x29, _x30) {
    return _ref12.apply(this, arguments);
  };
}();
export var getPostCodeAddresses = function () {
  var _ref13 = _asyncToGenerator(function* (postCode, token) {
    return yield executeGraphQLQuery(GET_ADDRESSES, {
      searchTerm: postCode
    }, result => {
      var _result$data0;
      return result === null || result === void 0 || (_result$data0 = result.data) === null || _result$data0 === void 0 ? void 0 : _result$data0.partialAddress;
    }, token);
  });
  return function getPostCodeAddresses(_x31, _x32) {
    return _ref13.apply(this, arguments);
  };
}();
export var getAccountList = function () {
  var _ref14 = _asyncToGenerator(function* (token) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var logContext = arguments.length > 2 ? arguments[2] : undefined;
    if (!token || typeof token === 'string' && !token.trim()) {
      return [];
    }
    var accounts = yield executeGraphQLQuery(GET_ACCOUNT_LIST, {
      viewAll: false
    }, result => {
      var _result$data1;
      return result === null || result === void 0 || (_result$data1 = result.data) === null || _result$data1 === void 0 || (_result$data1 = _result$data1.getAccountList) === null || _result$data1 === void 0 ? void 0 : _result$data1.accounts;
    }, token, true, false, headers, logContext);
    return accounts === null || accounts === void 0 ? void 0 : accounts.filter(account => account.accountNumber);
  });
  return function getAccountList(_x33) {
    return _ref14.apply(this, arguments);
  };
}();
export var getServerUnleashToggles = function () {
  var _ref15 = _asyncToGenerator(function* (label, fallbackFlags, url, query) {
    var _tracingCookie$name;
    var context = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var cookiesFn = yield getNextCookies();
    var cookieStore = cookiesFn ? yield cookiesFn() : null;
    if (!cookieStore) {
      return fallbackFlags;
    }
    var tracingCookie = cookieStore.get(DEFAULT_TRACING_COOKIE_NAME);
    return getUnleashTogglesServerOrClient(cookieStore, label, fallbackFlags, url, query, {
      [DEFAULT_TRACING_COOKIE_NAME]: (_tracingCookie$name = tracingCookie === null || tracingCookie === void 0 ? void 0 : tracingCookie.name) !== null && _tracingCookie$name !== void 0 ? _tracingCookie$name : ''
    }, context);
  });
  return function getServerUnleashToggles(_x34, _x35, _x36, _x37) {
    return _ref15.apply(this, arguments);
  };
}();
export function getActivePath(currentPath, navObj) {
  var _Object$values$find$l, _Object$values;
  return (_Object$values$find$l = (_Object$values = Object.values(navObj)) === null || _Object$values === void 0 || (_Object$values = _Object$values.find(value => currentPath === null || currentPath === void 0 ? void 0 : currentPath.includes(value === null || value === void 0 ? void 0 : value.path))) === null || _Object$values === void 0 ? void 0 : _Object$values.label) !== null && _Object$values$find$l !== void 0 ? _Object$values$find$l : '';
}
export var getLocaleByPathname = pathname => {
  if (!pathname) return LOCALES.EN;
  var segments = pathname.split('/');
  var locale = segments[1].toLowerCase();
  var mappedLocale = {
    en: LOCALES.EN,
    gb: LOCALES.EN,
    de: LOCALES.DE
  };
  return mappedLocale[locale] || locale;
};
export var getCountryLanguageByLocale = locale => {
  if (locale === CountryCode.DE) {
    return {
      country: CountryCode.DE,
      language: CountryCode.DE
    };
  }
  return {
    country: locale === LOCALES.DE ? CountryCode.DE : CountryCode.GB,
    language: locale === LOCALES.DE ? CountryCode.DE : CountryCode.EN
  };
};
export var getInnBusinessServerSideProps = function () {
  var _ref16 = _asyncToGenerator(function* (token, language) {
    var needsFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var businessBookerRequestHeaders = arguments.length > 3 ? arguments[3] : undefined;
    try {
      var headers = businessBookerRequestHeaders ? getBusinessBookerIpHeaders(businessBookerRequestHeaders) : undefined;
      var footerPromise = needsFooter ? getFooterLabels(language) : Promise.resolve(undefined);
      var _getDetailsFromToken2 = getDetailsFromToken(token),
        companyId = _getDetailsFromToken2.companyId;
      var _yield$Promise$all3 = yield Promise.all([getUserDetails(token, true, headers), getInnBusinessHeaderLabels(language), getCommonIcons(language), getCardManagementLabels(language), getAccountList(token, headers), getUserManagementLabels(language), getSpendingLabels(language), getSearchRules(token), getInnBusinessLayoutLabels(language), getCompanyDetails(companyId, token), getNotificationsLabels(language), footerPromise]),
        _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 12),
        userDetails = _yield$Promise$all4[0],
        labels = _yield$Promise$all4[1],
        icons = _yield$Promise$all4[2],
        cards = _yield$Promise$all4[3],
        accounts = _yield$Promise$all4[4],
        users = _yield$Promise$all4[5],
        spending = _yield$Promise$all4[6],
        searchRules = _yield$Promise$all4[7],
        layout = _yield$Promise$all4[8],
        companyDetails = _yield$Promise$all4[9],
        notifications = _yield$Promise$all4[10],
        footer = _yield$Promise$all4[11];
      return {
        labels,
        icons,
        cards,
        users,
        accounts,
        spending,
        userDetails,
        companyDetails,
        footer: footer !== null && footer !== void 0 ? footer : null,
        language,
        isAccountHolder: hasAccountHolder(accounts),
        isCardHolder: hasCardHolder(accounts),
        searchRules,
        layout,
        notifications
      };
    } catch (_unused3) {
      return null;
    }
  });
  return function getInnBusinessServerSideProps(_x38, _x39) {
    return _ref16.apply(this, arguments);
  };
}();
export var getHotelInformationIB = function () {
  var _ref17 = _asyncToGenerator(function* (hotelId, language) {
    return yield executeGraphQLQuery(GET_HOTEL_INFORMATION, {
      hotelId,
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data10;
      return result === null || result === void 0 || (_result$data10 = result.data) === null || _result$data10 === void 0 ? void 0 : _result$data10.hotelInformation;
    });
  });
  return function getHotelInformationIB(_x40, _x41) {
    return _ref17.apply(this, arguments);
  };
}();
export var getHotelAvailabilitiesIB = function () {
  var _ref18 = _asyncToGenerator(function* (hotelId, arrival, departure, brand, country, rooms, language, bookingChannel, channel, token) {
    return yield executeGraphQLQuery(HOTEL_AVAILABILITY_QUERY, {
      hotelId,
      arrival,
      departure,
      brand,
      country,
      rooms,
      language,
      bookingChannel,
      channel
    }, result => result === null || result === void 0 ? void 0 : result.data, token);
  });
  return function getHotelAvailabilitiesIB(_x42, _x43, _x44, _x45, _x46, _x47, _x48, _x49, _x50, _x51) {
    return _ref18.apply(this, arguments);
  };
}();
export var staticHotelInformationIB = cachePromise(function () {
  var _ref19 = _asyncToGenerator(function* (slug, language) {
    return yield executeGraphQLQuery(STATIC_HOTEL_INFORMATION_QUERY, {
      slug,
      country: language === 'en' ? 'gb' : 'de',
      language
    }, result => {
      var _result$data11;
      return result === null || result === void 0 || (_result$data11 = result.data) === null || _result$data11 === void 0 ? void 0 : _result$data11.hotelInformationBySlug;
    });
  });
  return function (_x52, _x53) {
    return _ref19.apply(this, arguments);
  };
}());
export { roomDefaultValueIfError };
export var getDaysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};
export var getCountryName = (countryCode, countries) => {
  if (countryCode === 'D') {
    countryCode = ShortCountry.DE;
  }
  var country = countries.find(country => country.countryCode === countryCode);
  return country === null || country === void 0 ? void 0 : country.countryName;
};
export var getFormattedAddress = function () {
  var _ref20 = _asyncToGenerator(function* (addressId) {
    return yield executeGraphQLQuery(GET_FORMATTED_ADDRESS, {
      identifier: encodeURIComponent(addressId)
    }, result => {
      var _result$data12;
      return result === null || result === void 0 || (_result$data12 = result.data) === null || _result$data12 === void 0 ? void 0 : _result$data12.formattedAddress;
    });
  });
  return function getFormattedAddress(_x54) {
    return _ref20.apply(this, arguments);
  };
}();
export var getEmployeesCSV = function () {
  var _ref21 = _asyncToGenerator(function* (token, companyId) {
    if (!companyId) {
      return null;
    }
    try {
      yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/companies/").concat(companyId, "/employees/bulk"), {
        method: 'GET',
        headers: {
          Authorization: "Bearer ".concat(token)
        },
        cache: 'no-cache'
      }).then(data => data.blob()).then(response => resolveAndDownloadBlob(response, 'Employees', '.csv'));
    } catch (error) {
      return null;
    }
  });
  return function getEmployeesCSV(_x55, _x56) {
    return _ref21.apply(this, arguments);
  };
}();
export var getCompanyRegistrationQuestionsAndAnswers = function () {
  var _ref22 = _asyncToGenerator(function* (companyId, headers, logContext) {
    var _cookieStore$get$valu4, _cookieStore$get4;
    var cookiesFn = yield getNextCookies();
    var cookieStore = cookiesFn ? yield cookiesFn() : null;
    var token = (_cookieStore$get$valu4 = cookieStore === null || cookieStore === void 0 || (_cookieStore$get4 = cookieStore.get(ID_TOKEN_COOKIE)) === null || _cookieStore$get4 === void 0 ? void 0 : _cookieStore$get4.value) !== null && _cookieStore$get$valu4 !== void 0 ? _cookieStore$get$valu4 : '';
    try {
      var res = yield executeGraphQLQuery(getCompanyRegistrationQuestionsQuery(), {
        companyId
      }, result => {
        var _result$data13;
        return parseRegistrationQuestions(result === null || result === void 0 || (_result$data13 = result.data) === null || _result$data13 === void 0 ? void 0 : _result$data13.getCompanyRegistrationQuestionsAndAnswers);
      }, token, true, true, headers, logContext);
      return res;
    } catch (error) {
      throw new Error('Error fetching company registration questions and answers');
    }
  });
  return function getCompanyRegistrationQuestionsAndAnswers(_x57, _x58, _x59) {
    return _ref22.apply(this, arguments);
  };
}();
var DEFAULT_CONTACT_PREFERENCE = email => ({
  permissions: [{
    brandCode: BRANDCODES[0],
    brand: 'Premier Inn',
    optIn: false,
    secondOptInReq: null,
    secondOptIn: null,
    secondPartyOptIn: false,
    thirdPartyVendorsOptIn: false,
    suppressMarketingCheckbox: false
  }],
  loyaltyAccounts: [],
  valid: true,
  deleted: false,
  contactChannelId: null,
  contactChannelValue: email
});
export var getContactPreferences = function () {
  var _ref23 = _asyncToGenerator(function* (email, token, countryOfResidenceOrLogContext, language, logContext) {
    if (!token) {
      throw new Error('Authentication token is required');
    }
    if (!email) {
      throw new Error('Email is required');
    }
    var countryOfResidence = typeof countryOfResidenceOrLogContext === 'string' ? countryOfResidenceOrLogContext : undefined;
    var resolvedLogContext = typeof countryOfResidenceOrLogContext === 'object' ? countryOfResidenceOrLogContext : logContext;
    var variables = {
      request: {
        contactType: 'email',
        contactValue: email,
        brandCodes: BRANDCODES[0],
        business: true,
        contactChannelId: null,
        countryOfResidence,
        language
      }
    };
    try {
      var result = yield executeGraphQLQuery(GET_CONTACT_PREFERENCES, variables, result => {
        if (!(result !== null && result !== void 0 && result.errors)) {
          var _result$data14;
          return result === null || result === void 0 || (_result$data14 = result.data) === null || _result$data14 === void 0 ? void 0 : _result$data14.getContactPreferences;
        }
        var hasAppSyncError = result.errors.some(error => error.message === 'appsync.global.error');
        if (hasAppSyncError) {
          return DEFAULT_CONTACT_PREFERENCE(email);
        }
        return null;
      }, token, true, true, undefined, resolvedLogContext);
      return result !== null && result !== void 0 ? result : DEFAULT_CONTACT_PREFERENCE(email);
    } catch (error) {
      return DEFAULT_CONTACT_PREFERENCE(email);
    }
  });
  return function getContactPreferences(_x60, _x61, _x62, _x63, _x64) {
    return _ref23.apply(this, arguments);
  };
}();
export var getSelectedAccountHolder = (accounts, accountNumber) => {
  var currentAccount = accounts[0];
  if (accountNumber) {
    var account = accounts.find(account => String(account.tetheredGuid) === accountNumber);
    if (account) {
      currentAccount = account;
    }
  }
  return currentAccount;
};
export var getManagementInformationReport = function () {
  var _ref24 = _asyncToGenerator(function* (token, fromDate, toDate, showQnAcolumns, language) {
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var revalidateCache = false;
    var returnErrors = true;
    var response = yield executeGraphQLQuery(managementInformationReportQuery(), {
      fromDate,
      toDate,
      showQnAcolumns,
      language
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getManagementInformationReport(_x65, _x66, _x67, _x68, _x69) {
    return _ref24.apply(this, arguments);
  };
}();
export var getEmergencyReport = function () {
  var _ref25 = _asyncToGenerator(function* (token, language) {
    var revalidateCache = false;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(emergencyReportQuery(), {
      language
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getEmergencyReport(_x70, _x71) {
    return _ref25.apply(this, arguments);
  };
}();
export var getPIBACardDetails = function () {
  var _ref26 = _asyncToGenerator(function* (token, cardId, tetheredUserId, countryCode, logContext) {
    return yield executeGraphQLQuery(getPibaCardDetailsQuery(), {
      tetheredUserId,
      countryCode,
      cardId
    }, result => {
      var _result$data15;
      return result === null || result === void 0 || (_result$data15 = result.data) === null || _result$data15 === void 0 ? void 0 : _result$data15.getPIBACardDetails;
    }, token, true, false, undefined, logContext);
  });
  return function getPIBACardDetails(_x72, _x73, _x74, _x75, _x76) {
    return _ref26.apply(this, arguments);
  };
}();
export var getAllPibaCards = function () {
  var _ref27 = _asyncToGenerator(function* (token, scheme, tetheredUserId, includeCancelledCards, showMyCards, pageIndex, pageSize) {
    return yield executeGraphQLQuery(getAllPibaCardsQuery(), {
      tetheredUserId,
      countryCode: scheme,
      pibaCardsCriteria: {
        userId: tetheredUserId,
        includeCancelledCards,
        showMyCards,
        pageNumber: pageIndex,
        maxRows: pageSize
      }
    }, result => {
      var _result$data16;
      return result === null || result === void 0 || (_result$data16 = result.data) === null || _result$data16 === void 0 ? void 0 : _result$data16.getAllPIBACards;
    }, token, true);
  });
  return function getAllPibaCards(_x77, _x78, _x79, _x80, _x81, _x82, _x83) {
    return _ref27.apply(this, arguments);
  };
}();
export var getCompanySpending = function () {
  var _ref28 = _asyncToGenerator(function* (token, fromMonthYear, toMonthYear) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(getCompanySpendingQuery(), {
      fromMonthYear,
      toMonthYear
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getCompanySpending(_x84, _x85, _x86) {
    return _ref28.apply(this, arguments);
  };
}();
export var getYourSpending = function () {
  var _ref29 = _asyncToGenerator(function* (token, employeeSpendCriteria) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(getYourSpendingQuery(), {
      employeeSpendCriteria
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getYourSpending(_x87, _x88) {
    return _ref29.apply(this, arguments);
  };
}();
export var getUpcomingBookings = function () {
  var _ref30 = _asyncToGenerator(function* (token, params) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(getUpcomingBookingsQuery(), params, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getUpcomingBookings(_x89, _x90) {
    return _ref30.apply(this, arguments);
  };
}();
export var getUpcomingSpending = function () {
  var _ref31 = _asyncToGenerator(function* (token, accountId, tetheredUserGuid) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(getUpcomingSpendingQuery(), {
      accountId,
      tetheredUserGuid
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getUpcomingSpending(_x91, _x92, _x93) {
    return _ref31.apply(this, arguments);
  };
}();
export var getPaymentCards = function () {
  var _ref32 = _asyncToGenerator(function* (token, companyId) {
    return yield executeGraphQLQuery(getPaymentCardsQuery(), {
      companyId
    }, result => {
      var _result$data17;
      return result === null || result === void 0 || (_result$data17 = result.data) === null || _result$data17 === void 0 ? void 0 : _result$data17.getPaymentCards;
    }, token, true);
  });
  return function getPaymentCards(_x94, _x95) {
    return _ref32.apply(this, arguments);
  };
}();
export var companyDetailsLookup = function () {
  var _ref33 = _asyncToGenerator(function* (token, companyRegistrationNumber, scheme) {
    return yield executeGraphQLQuery(companyDetailsLookupQuery(), {
      companyRegistrationNumber,
      scheme
    }, result => {
      var _result$data18;
      return result === null || result === void 0 || (_result$data18 = result.data) === null || _result$data18 === void 0 ? void 0 : _result$data18.companyDetailsLookup;
    }, token, true);
  });
  return function companyDetailsLookup(_x96, _x97, _x98) {
    return _ref33.apply(this, arguments);
  };
}();
export var getPayApplications = function () {
  var _ref34 = _asyncToGenerator(function* (token) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(getPayApplicationsQuery(), {}, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getPayApplications(_x99) {
    return _ref34.apply(this, arguments);
  };
}();
export var getNotifications = function () {
  var _ref35 = _asyncToGenerator(function* (token, scheme, tetheredUserId) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(getNotificationsQuery(), {
      scheme,
      tetheredUserId
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getNotifications(_x100, _x101, _x102) {
    return _ref35.apply(this, arguments);
  };
}();
var formatAccountNumber = accountNumber => {
  if (!accountNumber) return '';
  return accountNumber.replace(/(\d{4})/g, '$1 ').trim();
};
export var getWorldlineUserPreferences = function () {
  var _ref36 = _asyncToGenerator(function* (token, logContext) {
    if (!token) return null;
    try {
      var accounts = yield getAccountList(token, {}, logContext);
      if (!(accounts !== null && accounts !== void 0 && accounts.length)) return null;
      var validAccounts = accounts.filter(acc => !!(acc !== null && acc !== void 0 && acc.tetheredGuid) && !!(acc !== null && acc !== void 0 && acc.accountName) && !!(acc !== null && acc !== void 0 && acc.accountNumber) && Array.isArray(acc === null || acc === void 0 ? void 0 : acc.registrationRoles));
      if (!validAccounts.length) return null;
      var preferencesData = yield executeGraphQLQuery(WORLDLINE_USER_PREFERENCES_QUERY, {
        tetheredUserGuids: validAccounts.map(acc => acc.tetheredGuid)
      }, result => {
        var _data;
        return result === null || result === void 0 || (_data = result.data) === null || _data === void 0 ? void 0 : _data.getWorldlineUserPreferences;
      }, token, true, false, undefined, logContext);
      if (!(preferencesData !== null && preferencesData !== void 0 && preferencesData.length)) return null;
      var accountMap = new Map(validAccounts.map(acc => [acc.tetheredGuid, acc]));
      return preferencesData.map(pref => {
        var account = accountMap.get(pref.tetheredUserGuid);
        if (!account) return null;
        var result = {
          tetheredUserGuid: pref.tetheredUserGuid,
          settings: pref.settings,
          preferenceDetails: pref.details,
          accountName: account.accountName,
          registrationRoles: account.registrationRoles,
          accountNumber: formatAccountNumber(account.accountNumber)
        };
        return result;
      }).filter(item => item !== null);
    } catch (_unused4) {
      return null;
    }
  });
  return function getWorldlineUserPreferences(_x103, _x104) {
    return _ref36.apply(this, arguments);
  };
}();
export var getAppLookupData = function () {
  var _ref37 = _asyncToGenerator(function* (scheme, token) {
    return yield executeGraphQLQuery(scheme === 'GB' ? getAppLookupDataQueryEN : getAppLookupDataQueryDE, {
      scheme
    }, result => {
      var _result$data19;
      return result === null || result === void 0 || (_result$data19 = result.data) === null || _result$data19 === void 0 ? void 0 : _result$data19.getAppLookupData;
    }, token);
  });
  return function getAppLookupData(_x105, _x106) {
    return _ref37.apply(this, arguments);
  };
}();
export var getSearchRules = function () {
  var _ref38 = _asyncToGenerator(function* (token) {
    return yield executeGraphQLQuery(GET_SEARCH_RULES_QUERY, {
      channel: 'BB'
    }, result => result === null || result === void 0 ? void 0 : result.data, token);
  });
  return function getSearchRules(_x107) {
    return _ref38.apply(this, arguments);
  };
}();
export var getPayApplicationDetails = function () {
  var _ref39 = _asyncToGenerator(function* (token, applicationGuid, applicationId, scheme, logContext) {
    return yield executeGraphQLQuery(getPayApplicationDetailsQuery(), {
      applicationGuid,
      applicationId,
      scheme
    }, result => {
      var _result$errors;
      if (result !== null && result !== void 0 && (_result$errors = result.errors) !== null && _result$errors !== void 0 && _result$errors.length) {
        var _JSON$parse, _result$errors$;
        return {
          errCode: (_JSON$parse = JSON.parse(result === null || result === void 0 || (_result$errors$ = result.errors[0]) === null || _result$errors$ === void 0 ? void 0 : _result$errors$.message)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.errCode
        };
      }
      return result === null || result === void 0 ? void 0 : result.data.getApplicationDetails;
    }, token, true, true, undefined, logContext);
  });
  return function getPayApplicationDetails(_x108, _x109, _x110, _x111, _x112) {
    return _ref39.apply(this, arguments);
  };
}();
export var getActivationDetails = function () {
  var _ref40 = _asyncToGenerator(function* (activationKey, logContext) {
    return yield executeGraphQLQuery(getActivationDetailsQuery(), {
      activationKey
    }, result => {
      var _result$data20;
      return result === null || result === void 0 || (_result$data20 = result.data) === null || _result$data20 === void 0 ? void 0 : _result$data20.getActivationDetails;
    }, undefined, false, false, undefined, logContext);
  });
  return function getActivationDetails(_x113, _x114) {
    return _ref40.apply(this, arguments);
  };
}();
export var getRegistrationInfo = function () {
  var _ref41 = _asyncToGenerator(function* (token, registrationCode, logContext) {
    return yield executeGraphQLQuery(getRegistrationInfoQuery(), {
      registrationCode
    }, result => {
      var _result$data21;
      return result === null || result === void 0 || (_result$data21 = result.data) === null || _result$data21 === void 0 ? void 0 : _result$data21.getRegistrationInfo;
    }, token, true, false, undefined, logContext);
  });
  return function getRegistrationInfo(_x115, _x116, _x117) {
    return _ref41.apply(this, arguments);
  };
}();
export var MANAGE_TABS = {
  INN_BUSINESS: 'innbusiness',
  INN_BUSINESS_PAY: 'innbusiness-pay'
};
export function getAvailableTabs(isTravelManager, isTethered, hasAccountHolder) {
  var hasCardHolder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var forCardManagement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isDeLanguage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var isPibaEuroEnabled = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var hasCostCenterHolder = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var isBusinessPayManager = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
  if (!isTravelManager && !hasAccountHolder && !hasCardHolder && !hasCostCenterHolder && !isBusinessPayManager) {
    return [];
  }
  var hasOnlyFinanceUser = isTethered && !hasAccountHolder && !hasCardHolder;
  var isBPMNonCardManagement = isBusinessPayManager && !forCardManagement;
  if ((isTravelManager || isBPMNonCardManagement) && isDeLanguage && !isTethered && !isPibaEuroEnabled) {
    return [MANAGE_TABS.INN_BUSINESS];
  }
  var tabs = new Set();
  if (isTravelManager || isBPMNonCardManagement) {
    tabs.add(MANAGE_TABS.INN_BUSINESS);
    if (!hasOnlyFinanceUser) {
      tabs.add(MANAGE_TABS.INN_BUSINESS_PAY);
    }
  }
  if (forCardManagement) {
    if (showCardManagementForBusinessPayManager(isBusinessPayManager, isDeLanguage, isTethered, isPibaEuroEnabled, hasAccountHolder, hasCardHolder)) {
      tabs.add(MANAGE_TABS.INN_BUSINESS_PAY);
    }
    if (isTethered && (hasCardHolder || hasAccountHolder || hasCostCenterHolder)) {
      tabs.add(MANAGE_TABS.INN_BUSINESS_PAY);
    }
  } else {
    if (isTethered && hasAccountHolder) {
      tabs.add(MANAGE_TABS.INN_BUSINESS_PAY);
    }
  }
  return Array.from(tabs).slice(0, 2);
}
export var getWorldlineReturnUrl = (locale, path) => {
  return "".concat(process.env.NEXT_PUBLIC_WORLDLINE_RETURN_URL).concat(getPathForLocale(locale, path));
};
export var getMarketingPreferences = function () {
  var _ref42 = _asyncToGenerator(function* (brandCode, email, countryOfResidence, language) {
    return yield executeGraphQLQuery(GET_ANONYMOUS_NEWSLETTER_PREFERENCES, {
      brandCode,
      email,
      countryOfResidence,
      language
    }, result => {
      var _result$data22;
      return result === null || result === void 0 || (_result$data22 = result.data) === null || _result$data22 === void 0 ? void 0 : _result$data22.anonymousNewsletterPreferences;
    });
  });
  return function getMarketingPreferences(_x118, _x119, _x120, _x121) {
    return _ref42.apply(this, arguments);
  };
}();
export var getSpendOverTimeCSV = function () {
  var _ref43 = _asyncToGenerator(function* (token, accountNumber, fromMonthYear, toMonthYear, scheme, language) {
    if (!token || !accountNumber || !fromMonthYear || !toMonthYear || !scheme || !language) {
      return null;
    }
    var response = yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/v1/spending/accountSpending?pibaAccountId=").concat(accountNumber, "&fromMonthYear=").concat(fromMonthYear, "&toMonthYear=").concat(toMonthYear, "&scheme=").concat(scheme, "&language=").concat(language), {
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(token),
        'WB-Authorization': "Bearer ".concat(token),
        accept: 'text/csv'
      },
      cache: 'no-cache'
    });
    if (!response.ok) {
      throw new Error("Failed to fetch CSV: ".concat(response.statusText));
    }
    var contentDisposition = response.headers.get('content-disposition');
    var filename = (contentDisposition === null || contentDisposition === void 0 ? void 0 : contentDisposition.split('filename=')[1]) || 'Inn Business Pay Spend Over Time';
    var blob = yield response.blob();
    resolveAndDownloadBlob(blob, filename, '');
  });
  return function getSpendOverTimeCSV(_x122, _x123, _x124, _x125, _x126, _x127) {
    return _ref43.apply(this, arguments);
  };
}();
export var getAccountSpending = function () {
  var _ref44 = _asyncToGenerator(function* (token, fromMonthYear, toMonthYear, pibaAccountId, tetheredUserGuid) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token || !fromMonthYear || !toMonthYear || !pibaAccountId) {
      return null;
    }
    var response = yield executeGraphQLQuery(getAccountSpendingQuery(), {
      accountSpendingCriteria: {
        fromMonthYear,
        toMonthYear,
        pibaAccountId,
        tetheredUserGuid
      }
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getAccountSpending(_x128, _x129, _x130, _x131, _x132) {
    return _ref44.apply(this, arguments);
  };
}();
export var getAccountTransactions = function () {
  var _ref45 = _asyncToGenerator(function* (token, payload) {
    var revalidateCache = true;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(viewAccountTransactionsQuery(), {
      payload
    }, result => result, token, revalidateCache, returnErrors);
    return response;
  });
  return function getAccountTransactions(_x133, _x134) {
    return _ref45.apply(this, arguments);
  };
}();
export var getOutOfPolicyReport = function () {
  var _ref46 = _asyncToGenerator(function* (token, companyId, fromDate, toDate) {
    if (!token || !companyId || !fromDate || !toDate) {
      return null;
    }
    try {
      yield fetch("".concat(process.env.NEXT_PUBLIC_REST_API, "/companies/admin/").concat(companyId, "/reports/out-of-office?fromDate=").concat(fromDate, "&toDate=").concat(toDate), {
        method: 'GET',
        headers: {
          Authorization: "Bearer ".concat(token)
        },
        cache: 'no-cache'
      }).then(data => data.blob()).then(response => resolveAndDownloadBlob(response, 'OutOfPolicyReport', '.csv'));
    } catch (error) {
      return null;
    }
  });
  return function getOutOfPolicyReport(_x135, _x136, _x137, _x138) {
    return _ref46.apply(this, arguments);
  };
}();
export var getIBActivationDetails = function () {
  var _ref47 = _asyncToGenerator(function* (activationKey, logContext) {
    try {
      return yield executeGraphQLQuery(getIBActivationDetailsQuery(), {
        activationKey
      }, result => {
        var _result$data23;
        return result === null || result === void 0 || (_result$data23 = result.data) === null || _result$data23 === void 0 ? void 0 : _result$data23.getInnBusinessActivationDetailsV2;
      }, '', true, true, undefined, logContext);
    } catch (error) {
      return null;
    }
  });
  return function getIBActivationDetails(_x139, _x140) {
    return _ref47.apply(this, arguments);
  };
}();
export var getEmployeesWithFilteringOptions = function () {
  var _ref48 = _asyncToGenerator(function* (companyId, size, token, page, searchCriteria, pageToken, bookingChannel, awaitingApproval, shouldFilterEmployees, logContext) {
    return yield executeGraphQLQuery(getEmployeesWithFilteringOptionsQuery(), {
      companyId,
      size,
      page,
      searchCriteria,
      pageToken,
      bookingChannel,
      awaitingApproval,
      shouldFilterEmployees
    }, result => {
      var _result$data24;
      return result === null || result === void 0 || (_result$data24 = result.data) === null || _result$data24 === void 0 ? void 0 : _result$data24.getEmployeesWithFilteringOptionsV2;
    }, token, true, false, undefined, logContext);
  });
  return function getEmployeesWithFilteringOptions(_x141, _x142, _x143, _x144, _x145, _x146, _x147, _x148, _x149, _x150) {
    return _ref48.apply(this, arguments);
  };
}();
export var getBusinessBookerIpHeaders = headers => {
  var _headers$xForwarded, _headers$TrueClient;
  return {
    'x-forwarded-for': String((_headers$xForwarded = headers['x-forwarded-for']) !== null && _headers$xForwarded !== void 0 ? _headers$xForwarded : ''),
    'True-Client-IP': String((_headers$TrueClient = headers['True-Client-IP']) !== null && _headers$TrueClient !== void 0 ? _headers$TrueClient : '')
  };
};
export var appPreCheck = function () {
  var _ref49 = _asyncToGenerator(function* (token, scheme) {
    var _response$data$appPre, _response$data;
    var revalidateCache = false;
    var returnErrors = true;
    if (!token) {
      throw new Error('Authentication token is required');
    }
    var response = yield executeGraphQLQuery(appPreCheckQuery(), {
      scheme
    }, result => result, token, revalidateCache, returnErrors);
    return (_response$data$appPre = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.appPreCheck) !== null && _response$data$appPre !== void 0 ? _response$data$appPre : null;
  });
  return function appPreCheck(_x151, _x152) {
    return _ref49.apply(this, arguments);
  };
}();
export var getEmployeeDataforUserPilot = function () {
  var _ref50 = _asyncToGenerator(function* (token) {
    if (!token) {
      return null;
    }
    try {
      var _companyDetails$reque, _companyDetails$reque2, _companyDetails$reque3, _companyDetails$reque4;
      var _getDetailsFromToken3 = getDetailsFromToken(token),
        companyId = _getDetailsFromToken3.companyId,
        employeeId = _getDetailsFromToken3.employeeId,
        accessLevel = _getDetailsFromToken3.accessLevel;
      var _yield$Promise$all5 = yield Promise.all([getAccountList(token), getCompanyDetails(companyId, token, false)]),
        _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 2),
        accounts = _yield$Promise$all6[0],
        companyDetails = _yield$Promise$all6[1];
      var userPilotData = {
        role: accessLevel !== null && accessLevel !== void 0 ? accessLevel : '',
        innBusinessPayRoles: getAllPayRoles(accounts),
        employeeId: employeeId !== null && employeeId !== void 0 ? employeeId : '',
        companyId: companyId !== null && companyId !== void 0 ? companyId : '',
        companySector: (_companyDetails$reque = companyDetails === null || companyDetails === void 0 || (_companyDetails$reque2 = companyDetails.requestedCompany) === null || _companyDetails$reque2 === void 0 || (_companyDetails$reque2 = _companyDetails$reque2.companyDetails) === null || _companyDetails$reque2 === void 0 ? void 0 : _companyDetails$reque2.companySector) !== null && _companyDetails$reque !== void 0 ? _companyDetails$reque : '',
        numberOfEmployees: (_companyDetails$reque3 = companyDetails === null || companyDetails === void 0 || (_companyDetails$reque4 = companyDetails.requestedCompany) === null || _companyDetails$reque4 === void 0 || (_companyDetails$reque4 = _companyDetails$reque4.companyDetails) === null || _companyDetails$reque4 === void 0 ? void 0 : _companyDetails$reque4.numberOfEmployees) !== null && _companyDetails$reque3 !== void 0 ? _companyDetails$reque3 : 0
      };
      return userPilotData;
    } catch (_unused5) {
      return null;
    }
  });
  return function getEmployeeDataforUserPilot(_x153) {
    return _ref50.apply(this, arguments);
  };
}();
export var getStatementsPdf = function () {
  var _ref51 = _asyncToGenerator(function* (token, tetheredUserGuid, schemeCustomerId, fileAutoID, statementDate, invoiceNo, scheme) {
    if (!token || !tetheredUserGuid || !schemeCustomerId || !fileAutoID || !statementDate || !invoiceNo || !scheme) {
      return null;
    }
    var url = "".concat(process.env.NEXT_PUBLIC_REST_API, "/v2/piba/account/invoices/download/").concat(schemeCustomerId, "/").concat(tetheredUserGuid, "/").concat(fileAutoID, "?scheme=").concat(scheme);
    var response = yield fetch(url, {
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(token),
        'WB-Authorization': "Bearer ".concat(token),
        accept: 'application/pdf'
      },
      cache: 'no-cache'
    });
    if (!response.ok) {
      throw new Error("Failed to fetch PDF");
    }
    var filename = "Invoice_".concat(invoiceNo, "_").concat(statementDate);
    var blob = yield response.blob();
    resolveAndDownloadBlob(blob, filename, '.pdf');
  });
  return function getStatementsPdf(_x154, _x155, _x156, _x157, _x158, _x159, _x160) {
    return _ref51.apply(this, arguments);
  };
}();
export var getStatementsXls = function () {
  var _ref52 = _asyncToGenerator(function* (token, tetheredUserGuid, schemeCustomerId, fileAutoID, statementDate, invoiceNo, scheme) {
    if (!token || !tetheredUserGuid || !schemeCustomerId || !fileAutoID || !statementDate || !invoiceNo || !scheme) {
      return null;
    }
    var url = "".concat(process.env.NEXT_PUBLIC_REST_API, "/v2/piba/account/transactions/download/").concat(schemeCustomerId, "/").concat(tetheredUserGuid, "/").concat(invoiceNo, "?scheme=").concat(scheme);
    var response = yield fetch(url, {
      method: 'GET',
      headers: {
        Authorization: "Bearer ".concat(token),
        'WB-Authorization': "Bearer ".concat(token),
        accept: 'application/vnd.ms-excel'
      },
      cache: 'no-cache'
    });
    if (!response.ok) {
      throw new Error("Failed to fetch XLS");
    }
    var filename = "Invoice_".concat(invoiceNo, "_").concat(statementDate);
    var blob = yield response.blob();
    resolveAndDownloadBlob(blob, filename, '.xls');
  });
  return function getStatementsXls(_x161, _x162, _x163, _x164, _x165, _x166, _x167) {
    return _ref52.apply(this, arguments);
  };
}();
export var showCardManagementForBusinessPayManager = (isBusinessPayManager, isDeSite, isTethered, isPibaEuroActive, isAccountHolder, isCardHolder) => {
  if (!isBusinessPayManager) {
    return false;
  }
  if (isDeSite && !isTethered && !isPibaEuroActive) {
    return false;
  }
  if (isTethered && !isAccountHolder && !isCardHolder) {
    return false;
  }
  return true;
};
export var setGuestFormData = function () {
  var _ref53 = _asyncToGenerator(function* (basketReferenceId, formData) {
    try {
      var response = yield fetch('/api/guest-details/set-guest-form-data', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          basketReferenceId,
          formData
        })
      });
      return response.ok;
    } catch (error) {
      logger.error({
        error
      }, 'SAVE_GUEST_FORM_DATA_FAILED');
      return false;
    }
  });
  return function setGuestFormData(_x168, _x169) {
    return _ref53.apply(this, arguments);
  };
}();
export var clearGuestFormData = function () {
  var _ref54 = _asyncToGenerator(function* (basketReferenceId) {
    try {
      var response = yield fetch('/api/guest-details/remove-guest-form-data', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          basketReferenceId
        })
      });
      return response.ok;
    } catch (error) {
      logger.error({
        error
      }, 'CLEAR_GUEST_FORM_DATA_FAILED');
      return false;
    }
  });
  return function clearGuestFormData(_x170) {
    return _ref54.apply(this, arguments);
  };
}();
export * from './queries';
export { getSpendingSummaryV2 } from './queries/spending/getSpendingSummaryV2';